/**
* Featured Activities List JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Activities List component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'featured-activities-list',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( document ).on( 'mouseenter', '.featured-activities-list .group:not(.is-active)', function() {
        $( this ).closest( 'section' ).find( '.group' ).not( this ).removeClass( 'is-active' );
        $( this ).addClass( 'is-active' );
        const image = $( this ).attr( 'data-front-image' );

        $( this ).closest( 'section' ).find( '.image-wrapper' ).removeClass( 'is-active' );
        $( image ).prevAll().removeClass( 'is-active' ).addClass( 'is-past' );
        $( image ).addClass( 'is-active' ).removeClass( 'is-past' );
        $( image ).nextAll().slice( 0, 3 ).addClass( 'is-active' );
        $( image ).nextAll().removeClass( 'is-past' );

        console.log( $( image ).nextAll().slice( 0, 3 ) );

        const currentRotation = -3;
        let newRotation = currentRotation - 3;
        if ( newRotation < -3 ) {
          newRotation = -3;
        }

        const deckRotation = $( this ).attr( 'data-rotation' );

        $( '.images-wrapper' ).css( 'transform', 'rotate(' + deckRotation + ')' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-activities-list', COMPONENT );
} )( app );
